import { usePlayers } from "./usePlayers";
import SelectInput from "@/components/form/select/newSelect";
import SearchInputApi from "@/components/search/SearchInputApi";

interface ClassYear {
  [key: string]: string;
}

const PlayerFilters = (props: {
  className?: string;
  setSearchResults: Function;
  setPlayerClass: Function;
  setPosition: Function;
}) => {
  const { settingsData, loadingSettings } = usePlayers();

  const positionOptions = [
    { value: "QB", label: "QB" }, // secondLabel: "Quarterback" },
    { value: "RB", label: "RB" }, // secondLabel: "Running Back" },
    { value: "SLOT", label: "SLOT" }, // secondLabel: "Slot Receiver" },
    { value: "WR", label: "WR" }, // secondLabel: "Wide Receiver" },
    { value: "TE", label: "TE" }, // secondLabel: "Tight End" },
    { value: "OL", label: "OL" }, // secondLabel: "Offensive Lineman" },
    { value: "DL", label: "DL" }, // secondLabel: "Defensive Lineman" },
    { value: "OLB", label: "OLB" }, // secondLabel: "Outside Linebacker" },
    { value: "ILB", label: "ILB" }, // secondLabel: "Inside Linebacker" },
    { value: "LB", label: "LB" }, // secondLabel: "Linebacker" },
    { value: "DE", label: "DE" }, // secondLabel: "Defensive End" },
    { value: "SAF", label: "SAF" }, // secondLabel: "Safety" },
    { value: "DB", label: "DB" }, // secondLabel: "Defensive Back" },
    { value: "K/P", label: "K/P" }, // secondLabel: "Kicker/Punter" },¿
    { value: "ATH", label: "ATH" } // secondLabel: "Athlete" }
  ];

  const classYears: ClassYear | undefined = settingsData?.classYears;

  const classOptions = [];

  classYears?.y1 && classOptions.push({ value: classYears.y1, label: classYears.y1 });
  classYears?.y2 && classOptions.push({ value: classYears.y2, label: classYears.y2 });
  classYears?.y3 && classOptions.push({ value: classYears.y3, label: classYears.y3 });

  return (
    <div className={props.className}>
      <div>
        <SearchInputApi
          throttle={1000}
          callback={(x) => props.setSearchResults(x)}
          className="flex items-center gap-2 justify-center px-4 py-2 min-w-28 bg-[#1F2731] rounded-full shadow-md focus:outline-none"
          placeholder="Search"
        />
      </div>
      <SelectInput
        options={positionOptions}
        onChange={(x) => props.setPosition(x)}
        default={{ value: "", label: "Position" }}
        className="flex items-center gap-2 justify-between px-4 py-2 w-40 lg:w-48 bg-[#1F2731] rounded-full shadow-md focus:outline-none"
        optionsClassName="absolute left-0 mt-2 w-40 lg:w-48 bg-[#1F2731] rounded-md shadow-lg max-h-40 overflow-y-auto z-[9]"
      />

      <SelectInput
        options={classOptions}
        onChange={(x) => props.setPlayerClass(x)}
        default={{ value: "", label: "Class" }}
        className="flex items-center justify-center gap-2 px-2 py-2 w-20 lg:w-28 bg-[#1F2731] rounded-full shadow-md focus:outline-none"
        optionsClassName="absolute left-0 mt-2 w-20 lg:w-28 bg-[#1F2731] rounded-md shadow-lg max-h-40 overflow-y-auto z-[9]"
        loading={loadingSettings}
      />
    </div>
  );
};

export default PlayerFilters;
